import { render } from "./Radwave.vue?vue&type=template&id=cc52917c&ts=true"
import script from "./Radwave.vue?vue&type=script&lang=ts"
export * from "./Radwave.vue?vue&type=script&lang=ts"

import "./Radwave.vue?vue&type=style&index=0&id=cc52917c&lang=less"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__